
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DomainCacheService } from './domain-cache.service';
import { Observable } from 'rxjs';

const baseRef = 'lotacao';
const route = {
  buscar: `${baseRef}/consultar`
}

@Injectable({
  providedIn: 'root'
})
export class LotacaoService {

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) { }

  listarLotacoes(): Observable<any> {
    return this.domainCache.getOrLoad('lotacao/consultar', () =>
      this.apiService.get<any>(route.buscar, undefined, undefined, true)
    );
  }
}
